import { List } from "antd"
import type { DeferredActionsListType } from "./types/DeferredActionsListType";
import ActionButton from "../../../../masterComponents/actionButton";
import { IoMdDoneAll } from "react-icons/io";
import { useMemo } from "react";
import { StyledDAContainer, StyledDATag } from "./styles/deferredActionsList.style";

const DeferredActionsList: React.FC<DeferredActionsListType> = ({ deferredActionsData, removeListRow, handleAttrStatChildSubmit, isLoadingExecuted, disabled }) => {

    const dataForSubmit = useMemo(() => deferredActionsData.map(item => ({
        target_value: item.targetValue,
        source_value: item.sourceValue,
        action_type: item.type,
        hash: item.hash,
    })), [deferredActionsData])

    return (
        <StyledDAContainer>
            <span>Deferred Actions</span>
            <List
                className="deferred-list"
                itemLayout="vertical"
                dataSource={deferredActionsData}
                renderItem={(item) => (
                    <List.Item>
                            {item.type === "SUBMIT" && (
                                <StyledDATag
                                    color="green"
                                    closable
                                    onClose={() => removeListRow(item.hash)}
                                >
                                    {`${item.sourceValue} -> ${item.targetValue}`}
                                </StyledDATag>
                            )}
                            {item.type === "CLEAR" && (
                                <StyledDATag
                                    color="red"
                                    closable
                                    onClose={() => removeListRow(item.hash)}
                                >
                                    {`CLEAR ${item.targetValue}`}
                                </StyledDATag>
                            )}
                    </List.Item>
                )}
            />
            <ActionButton
                text="Executed"
                className="primary-btn-color"
                icon={<IoMdDoneAll size={18} />}
                iconPosition="end"
                onClick={() => handleAttrStatChildSubmit(dataForSubmit)}
                loading={isLoadingExecuted}
                disabled={disabled}
            />
        </StyledDAContainer>
    )
}

export default DeferredActionsList;